'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nodeUuid = require('node-uuid');

var _FormControlComponent = require('./FormControlComponent');

var _FormControlComponent2 = _interopRequireDefault(_FormControlComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Handles input from a select input element.
 * @extends {Component}
 */
var SelectComponent = function (_React$Component) {
  _inherits(SelectComponent, _React$Component);

  function SelectComponent() {
    _classCallCheck(this, SelectComponent);

    return _possibleConstructorReturn(this, (SelectComponent.__proto__ || Object.getPrototypeOf(SelectComponent)).apply(this, arguments));
  }

  _createClass(SelectComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.optionKeys = this.props.options.map(function (element) {
        return { key: (0, _nodeUuid.v4)(), data: element };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.optionKeys = this.props.options.map(function (element) {
        return { key: (0, _nodeUuid.v4)(), data: element };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _FormControlComponent2.default,
        _extends({}, this.props, {
          field: this.props.field,
          formControlComponentClass: 'select',
          className: 'ingle-form-select',
          value: this.props.field.value || ''
        }),
        _react2.default.createElement(
          'option',
          { value: '', disabled: !this.props.defaultEnabled },
          (0, _translate.t)(this.props.placeholder)
        ),
        this.optionKeys.map(function (element) {
          return _react2.default.createElement(
            'option',
            { key: element.key, value: element.data.value },
            (0, _translate.t)(String(element.data.text))
          );
        })
      );
    }
  }]);

  return SelectComponent;
}(_react2.default.Component);

SelectComponent.propTypes = {
  field: _react2.default.PropTypes.object.isRequired,
  placeholder: _react2.default.PropTypes.string,
  options: _PropTypes.INPUT_OPTIONS_STRUCTURE.isRequired,
  defaultEnabled: _react2.default.PropTypes.bool
};
SelectComponent.defaultProps = {
  placeholder: 'Please select...'
};
exports.default = SelectComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/SelectComponent.jsx
// module id = 45
// module chunks = 0